import * as turf from '@turf/turf';

export class GeolocationService {
    private static statesGeoJson: any = null;

    private static readonly CIMIS_STATES = ['California'];
    private static readonly CROPNET_STATES = ['Hawaii', 'Guam'];
    private static readonly ASMET_STATES = ['Arizona'];

    private static readonly OPENET_STATES = [
        'California', 'Oregon', 'Washington', 'Idaho', 'Nevada', 'Utah',
        'Arizona', 'Montana', 'Wyoming', 'Colorado', 'New Mexico', 'North Dakota',
        'South Dakota', 'Nebraska', 'Kansas', 'Oklahoma', 'Texas'
    ];

    private static async loadGeoJson(): Promise<void> {
        if (!GeolocationService.statesGeoJson) {
            const response = await fetch('/assets/cropmanage-states.json');
            GeolocationService.statesGeoJson = await response.json();
        }
    }

    private static isPointInStates(lat: number, lng: number, stateNames: string[]): boolean {
        const point = turf.point([lng, lat]);
        return GeolocationService.statesGeoJson.features.some((feature: any) => {
            const name: string = feature.properties.NAME;
            return stateNames.indexOf(name) !== -1 &&
                turf.booleanPointInPolygon(point, feature);
        });
    }

    static async isLocationAllowed(lat: number, lng: number): Promise<boolean> {
        await GeolocationService.loadGeoJson();
        const point = turf.point([lng, lat]);
        return GeolocationService.statesGeoJson.features.some((feature: any) =>
            turf.booleanPointInPolygon(point, feature)
        );
    }

    static async isInCalifornia(lat: number, lng: number): Promise<boolean> {
        let result: boolean;

        await GeolocationService.loadGeoJson();
        result = GeolocationService.isPointInStates(lat, lng, GeolocationService.CIMIS_STATES);

        return result;
    }

    static async isInHawaiiOrGuam(lat: number, lng: number): Promise<boolean> {
        let result: boolean;

        await GeolocationService.loadGeoJson();
        result = GeolocationService.isPointInStates(lat, lng, GeolocationService.CROPNET_STATES);

        return result;
    }

    static async isInArizona(lat: number, lng: number): Promise<boolean> {
        let result: boolean;

        await GeolocationService.loadGeoJson();
        result = GeolocationService.isPointInStates(lat, lng, GeolocationService.ASMET_STATES);

        return result;
    }

    static async isInOpenETStates(lat: number, lng: number): Promise<boolean> {
        let result: boolean;

        await GeolocationService.loadGeoJson();
        result = GeolocationService.isPointInStates(lat, lng, GeolocationService.OPENET_STATES);

        return result;
    }
}